import React from 'react';
import {FormattedMessage} from 'react-intl';

import {sortArrayObjects} from '../sortArrayObjects';

export const getSeatTicketTraits = (eventLevelStats = {}) => {
  const {listingAttributeCategorySummary = []} = eventLevelStats;

  return listingAttributeCategorySummary.reduce((result, listingAttributeCategory) => {
    const {listingAttributeCategoryId} = listingAttributeCategory;
    if (SEAT_TRAITS[listingAttributeCategoryId]) {
      result[listingAttributeCategoryId] = {...SEAT_TRAITS[listingAttributeCategoryId], id: listingAttributeCategoryId};
    }

    return result && result.sort(sortArrayObjects('displayName'));
  }, []);
};

export const SEAT_TRAITS = {
  6: {
    name: 'aisle',
    displayName: <FormattedMessage id="EventSeatFeatures.aisle" defaultMessage="Aisle" />,
    iconSet: 'sh-iconset-aisleseat',
    type: 'include',
  },
  1: {
    name: 'excludeObstructView',
    displayName: (
      <FormattedMessage id="EventSeatFeatures.excludeObstructedView" defaultMessage="Exclude obstructed view" />
    ),
    iconSet: 'sh-iconset-obstructed',
    type: 'exclude',
  },
  4: {
    name: 'parkingPass',
    displayName: <FormattedMessage id="EventSeatFeatures.parkingPassIncluded" defaultMessage="Parking pass included" />,
    iconSet: 'sh-iconset-parking-2',
    type: 'include',
  },
  2: {
    name: 'wheelchair',
    displayName: (
      <FormattedMessage id="EventSeatFeatures.wheelChairAccessible" defaultMessage="Wheelchair accessible" />
    ),
    iconSet: 'sh-iconset-handicap',
    type: 'include',
  },
};
